import { ToastOptions } from 'ng2-toastr';

export class ToastOption extends ToastOptions {
    animate = 'fade';
    toastLife = 8000;
    positionClass = 'toast-bottom-right';
}


// WEBPACK FOOTER //
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/app/toast-option.ts